module.exports = __webpack_public_path__ + "media/brands/infiniti-97a9fb59.png";